/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-29 15:17:15
 * @LastEditTime: 2022-01-29 16:13:34
 * @LastEditors: zhao - 🍉
 * @Description: 商户详情
 * @FilePath: /zhzj-admin/src/page/HouseKeep/components/MerchantInfo.jsx
 */
import React, { useState, useRef } from "react";
import { useImperativeHandle } from "react";
import { forwardRef } from "react";
import MerchantDetail from '../../Merchant/components/UserInfo';
const MerchantInfo = (props, ref) => {
    const [visible, setVisible] = useState(false);
    const userAddRef = useRef()
    useImperativeHandle(ref, () => ({
        open
    }))
    const open = (id) => { //编辑
        setVisible(true)
        userAddRef.current.loadRole(false);
        userAddRef.current.loadPack({ id })
        userAddRef.current.initPack(id);
    }
    return <MerchantDetail 
                disabled
                onRef={ref => userAddRef.current = ref}
                visible={visible}
                handlecreateOrEdit={false}
                handleGetList={() => {}}
                handleCancel={() => setVisible(false) }
           />
}

export default forwardRef(MerchantInfo)


// WEBPACK FOOTER //
// ./src/page/HouseKeep/components/MerchantInfo.jsx